module.exports = __webpack_public_path__ + "img/p-lawn.db0053c7.jpg";